(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/startuninlogged.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/startuninlogged.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.StartUninlogged = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.startuninlogged(data);
    },
    regions: {
      spelpausInfoRegion: '#spelpausInfoRegion'
    },
    behaviors: {
      ServerSideRendering: {
        regionSetup: {
          spelpausInfoRegion: {
            view: svs.spelpaus.views.Info
          }
        }
      }
    }
  });
})(Backbone, _, svs);

 })(window);